import {VetReservation} from "./vet-reservation.model";
import {VisitXp} from "./visit-xp.model";

/**
 * Model agregujący dane z wyników badań laboratoryjnych i wiążący je
 * z konkretną wizytą w systemie rezerwacyjnym Vetineo oraz zewnętrznym systemie KlinikiXP.
 */
export class LabTestData {


  /** Vetcode kliniki, w której wykonano/zarejestrowano badanie. */
  public vetcodeId: number;

  /** Identyfikator powiązanej rezerwacji w Vetineo. */
  public vetResrvationUUID: string;

  /** Identyfikator powiązanej wizyty w zewnętrznym systemie KlinikiXP. */
  public visitXpUUID: string;

  /** Data wizyty, do której przypisano te wyniki badań laboratoryjnych. */
  public wizDate: string;


  /** Surowe dane wyników laboratoryjnych.
   */
  public labTestData: string;

  /** Wstępnie wyrenderowany widok wyników badań (np. gotowy blok HTML).
   */
  public renderedLabTestData: string;

  /** Identyfikator użytkownika, który autoryzował/zatwierdził te wyniki. */
  public labTestDataConfirmedByUserUUID: string;

  /** Data i czas formalnego zatwierdzenia wyników przez lekarza. */
  public labTestDataConfirmed: Date;

  /** Ogólny komentarz lekarza podsumowujący interpretację wyników badań pacjenta. */
  public labTestDataComment: string;

  constructor() {
  }


  /**
   * Metoda fabrykująca (Mapper) tworząca nowy obiekt LabTestData na podstawie
   * rezerwacji z Vetineo oraz rekordu wizyty z systemu zewnętrznego KlinikiXP.
   * @param vetReservation Obiekt rezerwacji z głównego systemu Vetineo.
   * @param visitXp Obiekt wizyty pobrany/zsynchronizowany z systemu zewnętrznego KlinikiXP.
   * @returns Wypełniona instancja LabTestData gotowa do zapisu lub transportu.
   */
  static getLabTestDatafromVetResrvation(vetReservation: VetReservation, visitXp: VisitXp): LabTestData {
    const labTestData: LabTestData = new LabTestData();


    labTestData.wizDate = visitXp.wizDate;
    labTestData.vetResrvationUUID = vetReservation.uuid;
    labTestData.vetcodeId = vetReservation.vetcodeId;
    labTestData.visitXpUUID = visitXp.uuid;

    labTestData.labTestData = visitXp.labTestData;
    labTestData.renderedLabTestData = visitXp.renderedLabTestData;

    labTestData.labTestDataConfirmedByUserUUID = visitXp.labTestDataConfirmedByUserUUID;
    labTestData.labTestDataComment = visitXp.labTestDataComment;
    labTestData.labTestDataConfirmed = visitXp.labTestDataConfirmed;

    return labTestData;
  }
}
